import { useAuthContext } from '@/components/Providers/AuthProvider';
import { LoadingIcon } from '@/components/svg';

const ReportsLoader: React.FC = () => {
  const { customer } = useAuthContext();

  return (
    <div className="v2-flex v2-flex-col v2-items-center gap-[8px]">
      <LoadingIcon fill="black" stroke="black" />
      <p className="v2-text-xl v2-font-medium v2-font-sweet-sans-pro-medium">Loading</p>
    </div>
  );
};

export default ReportsLoader;
